import { Navigate } from "react-router-dom";
// import PrivateContainer from "../templates/PrivateContainer";
// import Utils from "../utils";

const PublicAuth = ({ children }) => {
  return <>{children}</>;
};

export default PublicAuth;
 